var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTarifasAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9375 9C3.9375 8.68934 4.18934 8.4375 4.5 8.4375H13.5C13.8107 8.4375 14.0625 8.68934 14.0625 9C14.0625 9.31066 13.8107 9.5625 13.5 9.5625H4.5C4.18934 9.5625 3.9375 9.31066 3.9375 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.9375C9.31066 3.9375 9.5625 4.18934 9.5625 4.5V13.5C9.5625 13.8107 9.31066 14.0625 9 14.0625C8.68934 14.0625 8.4375 13.8107 8.4375 13.5V4.5C8.4375 4.18934 8.68934 3.9375 9 3.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0,
    d: "M17.5 0.5V17.5H0.5V0.5H17.5Z",
    stroke: "#9196B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTarifasAdd);
export default __webpack_public_path__ + "static/media/empty-tarifas-add.9855ad338640e8129498df3c8dc4d4d2.svg";
export { ForwardRef as ReactComponent };